export default __webpack_public_path__ + "static/media/19.32b23083.png";